import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType } from '@ngx-formly/core';
import moment from 'moment';
import { DatesFormats } from '@core/configs/date-config';
import { ReactiveFormsModule } from '@angular/forms';
import { CapturumValidatorComponent } from '@capturum/ui/api';
import { InputMask } from 'primeng/inputmask';

@Component({
  selector: 'app-patient-birthdate-at',
  templateUrl: './patient-birthdate-at.component.html',
  styleUrls: ['./patient-birthdate-at.component.scss'],
  imports: [ReactiveFormsModule, CapturumValidatorComponent, InputMask],
})
export class PatientBirthdateAtComponent extends FieldType implements OnInit {
  public mask: string = '99-99-9999';
  public inputFormat: string = DatesFormats.displayFormat.toLowerCase();
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    if (this.formControl.value) {
      this.formControl.setValue(
        moment(this.formControl.value, DatesFormats.sendFormat).format(DatesFormats.displayFormat),
        { emitEvent: false },
      );
    }

    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: string) => {
      return this.checkBirthdate(value);
    });
  }

  private checkBirthdate(date: string): void {
    const parts = date.split('-');

    if (parts.length === 3 && !parts[2].match(/y/)) {
      const birthdate = moment(date, DatesFormats.displayFormat);

      if (!birthdate.isValid() || birthdate.isAfter(moment())) {
        this.formControl.setValue('', { emitEvent: false });
      }
    }
  }
}
